export default {
    ProformaBillRows: 'البند|البنود',
};
